/**
 * Record Event function
 * Records an event in Google tag manager for marketing purposes
 * @param  {[String]} evt [Event name]
 * @param  {[String]} category [Event category]
 * @param  {[String]} action [Event action]
 * @param  {[String]} label [Event label]
 * @return {[Boolean]}
 */
const recordEvent = async (evt, category, action, label, currencyCode, saleValue, vcode) => {
  console.log('Recording', evt, category, action, label, currencyCode, saleValue, vcode);
  await window.dataLayer.push({
    event: evt,
    dl_category: category || '',
    dl_currencycode: currencyCode || '', //USD
    dl_salevalue: saleValue || '', //Shipment cost
    dl_vcode: vcode || '', //Promocode
    dl_action: action || '',
    dl_label: label || '',
  });
};

/**
 * Record Event function
 * Records an event in Google tag manager for marketing purposes
 * @param  {[String]} args [Any argument]
 */
const gtmPush = async (...args) => {
  console.log('GTM push', ...args);
  await window.dataLayer.push(...args);
};

export { recordEvent, gtmPush };


/** WEBPACK FOOTER **
 ** ./src/utils/analyticsEvents.js
 **/